<template>
  <div class="w-full flex flex-col">
    <HooksFilterBar
      :filters="filters"
      :text-search="textSearch"
      :live-status="liveStatus"
      :sort="sort"
      @update:textSearch="textSearch = $event"
      @update:live-status="liveStatus = $event"
      @update:sort="sort = $event"
      @update:dateRange="$emit('update:dateRange', $event)"
      @export="onExport"
    />
    <AdvertisementHooksList
      ref="hooksList"
      :filters="mergedFilters"
      :text-search="textSearch"
      :live-status="liveStatus"
      :sort="sort"
      @clear-search="textSearch = ''"
    />
  </div>
</template>

<script>
import AdvertisementHooksList from '../hooks/AdvertisementHooksList.vue'
import HooksFilterBar from '../hooks/HooksFilterBar.vue'
import { exportHooksCSV, copyHooksAsText } from '@/utils/hooks/hooksExport'

export default {
  name: 'HooksBrandView',
  components: {
    AdvertisementHooksList,
    HooksFilterBar
  },
  props: {
    filters: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      textSearch: '',
      sort: 'longest_running',
      liveStatus: ['live'],
    }
  },
  computed: {
    // Kept page-local so it never touches SpyderView's shared feed filters.
    mergedFilters () {
      return {
        ...this.filters,
        activeFilters: {
          ...(this.filters.activeFilters || {}),
          ...(this.liveStatus && { orLiveStatus: this.liveStatus })
        }
      }
    }
  },
  methods: {
    async onExport (payload) {
      const { format, scope } = payload
      const list = this.$refs.hooksList
      if (!list) return

      const groups = scope === 'pinned' ? list.pinnedGroups : list.groups

      try {
        if (format === 'csv') {
          exportHooksCSV(groups)
          this.$showAlert({ type: 'success', message: 'CSV exported' })
        } else if (format === 'text') {
          const copied = await copyHooksAsText(groups)
          if (copied) {
            this.$showAlert({ type: 'success', message: 'Copied to clipboard' })
          }
        }
      } catch (error) {
        console.error('Export error:', error)
        this.$showAlert({ type: 'error', message: 'Export failed' })
      }
    }
  }
}
</script>

<style scoped>
</style>
